import React, { useState, useEffect } from "react";
import { NavLink, Link, useNavigate } from "react-router-dom";
import logo from "../images/KubermaxLogo.png";
import { getStorage } from "../Utils/common";

const Header = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [eligibility, setEligibility] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = getStorage("token");
    const eligibilityStatus = getStorage("eligibility");

    if (token) {
      setIsLoggedIn(true);
    }

    if (eligibilityStatus) {
      setEligibility(eligibilityStatus);
    }
  }, []);

  const handleDashboardClick = () => {
    if (eligibility === 1) {
      navigate("/my-dashboard/eligibility");
    } else {
      navigate("/my-dashboard");
    }
    setMenuOpen(false);
  };

  return (
    //     <div className="bg-gradient-to-r from-[#1D3557] to-[#2563EB]
    //  relative shadow-md w-full z-50">
    //       <nav className="flex items-center justify-between px-4 py-2 md:px-8 h-20">
    //         {/* Logo */}
    //         <div className="flex items-center">
    //           <Link to="/">
    //             <img
    //               src={logo}
    //               alt="logo"
    //               className="rounded-lg p-1 w-36 h-auto"
    //             />
    //           </Link>
    //         </div>

    //         {/* Burger for mobile */}
    //         <div
    //           className="md:flex md:hidden flex-col z-20 justify-center cursor-pointer space-y-1"
    //           onClick={() => setMenuOpen(!menuOpen)}
    //         >
    //           <span className="block w-6 h-0.5 bg-white"></span>
    //           <span className="block w-6 h-0.5 bg-white"></span>
    //           <span className="block w-6 h-0.5 bg-white"></span>
    //         </div>

    //         {/* Nav Links */}
    //         <ul
    //           className={`p-5 md:p-0 flex flex-col md:flex-row items-center absolute md:static bg-white md:bg-transparent w-full md:w-auto top-[100%] -left-[100%] transition-all duration-300 ease-in-out ${menuOpen ? "left-[0] opacity-100" : "-left-[100%] opacity-0 md:opacity-100"
    //             } md:opacity-100`}
    //         >
    //           <li className="px-3 py-3 md:px-4 md:py-2 text-white font-bold">
    //             <NavLink
    //               to="/home"
    //               className="block text-black md:text-white hover:text-black"
    //               onClick={() => setMenuOpen(false)}
    //             >
    //               Home
    //             </NavLink>
    //           </li>
    //           <li className="px-3 py-3 md:px-4 md:py-2 text-white font-bold">
    //             <NavLink
    //               to="/about-us"
    //               className="block text-black md:text-white hover:text-black"
    //               onClick={() => setMenuOpen(false)}
    //             >
    //               About
    //             </NavLink>
    //           </li>
    //           <li className="px-3 py-3 md:px-4 md:py-2 text-white font-bold">
    //             <NavLink
    //               to="/contact"
    //               className="block text-black md:text-white hover:text-black"
    //               onClick={() => setMenuOpen(false)}
    //             >
    //               Contact
    //             </NavLink>
    //           </li>
    //           <li className="px-4 py-2 text-white">
    //             {isLoggedIn ? (
    //               <button
    //                 className="bg-[#FFD700] text-[#1D3557] px-5 py-3 md:px-4 md:py-2 rounded-lg hover:bg-[#FFE55C] w-full md:w-auto font-semibold"
    //                 onClick={handleDashboardClick}
    //               >
    //                 Dashboard
    //               </button>
    //             ) : (
    //               <NavLink
    //                 to="/apply-now"
    //                 className="bg-[#FFD700] text-[#1D3557] px-5 py-3 md:px-4 md:py-2 rounded-lg hover:bg-[#FFE55C] block text-center font-semibold"
    //                 onClick={() => setMenuOpen(false)}
    //               >
    //                 Apply Now
    //               </NavLink>
    //             )}
    //           </li>
    //           <li className="px-4 py-2">
    //             <NavLink
    //               to="/repayloan"
    //               className="bg-[#1D3557] text-white px-5 py-3 md:px-4 md:py-2 rounded-lg hover:bg-[#2D4567] block text-center"
    //               onClick={() => setMenuOpen(false)}
    //             >
    //               Repay Loan
    //             </NavLink>
    //           </li>
    //         </ul>
    //       </nav>
    //     </div>
    <div
      className="bg-[#050A18]
 relative shadow-lg w-full z-50"
    >
      <nav className="flex items-center justify-between px-5 md:px-12 h-20">
        {/* Logo */}
        <div className="flex items-center">
          <Link to="/">
            <img
              src={logo}
              alt="logo"
              className="rounded-lg p-1 w-36 h-auto drop-shadow-md"
            />
          </Link>
        </div>

        {/* Burger for mobile */}
        <button
          type="button"
          aria-label="Toggle navigation menu"
          aria-expanded={menuOpen}
          className="flex md:!hidden flex-col z-20 justify-center cursor-pointer space-y-1"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span className="block w-6 h-0.5 bg-white"></span>
          <span className="block w-6 h-0.5 bg-white"></span>
          <span className="block w-6 h-0.5 bg-white"></span>
        </button>

        {/* Nav Links */}
        <ul
          className={`p-4 md:p-0 pt-2 flex flex-col md:flex-row items-stretch md:items-center absolute md:static bg-[#050A18] md:bg-transparent left-3 right-3 md:left-auto md:right-auto top-[100%] md:top-auto rounded-2xl md:rounded-none border border-white/10 md:border-0 shadow-2xl md:shadow-none transition-all duration-300 ease-in-out
            ${menuOpen ? "translate-y-0 opacity-100 pointer-events-auto" : "-translate-y-2 opacity-0 pointer-events-none md:opacity-100 md:translate-y-0 md:pointer-events-auto"
            } md:opacity-100`}
        >
          <li className="px-3 py-1 md:px-4 md:py-2 font-semibold">
            <NavLink
              to="/home"
              className="block text-[white] md:text-white hover:text-[#40A0FF] transition"
              onClick={() => setMenuOpen(false)}
            >
              Home
            </NavLink>
          </li>

          <li className="px-3 py-1 md:px-4 md:py-2 font-semibold">
            <NavLink
              to="/about-us"
              className="block text-[white] md:text-white hover:text-[#40A0FF]  transition"
              onClick={() => setMenuOpen(false)}
            >
              About
            </NavLink>
          </li>

          <li className="px-3 py-1 md:px-4 md:py-2 font-semibold">
            <NavLink
              to="/contact"
              className="block text-[white] md:text-white hover:text-[#40A0FF]  transition"
              onClick={() => setMenuOpen(false)}
            >
              Contact
            </NavLink>
          </li>

          <li className="px-4 py-1">
            {isLoggedIn ? (
              <button
                className="bg-[#40A0FF]
            text-[white] px-6 py-3 md:px-4 md:py-2
            rounded-xl font-bold
            shadow-md hover:scale-105 transition-all
            w-full md:w-auto"
                onClick={handleDashboardClick}
              >
                Dashboard
              </button>
            ) : (
              <NavLink
                to="/apply-now"
                className="bg-gradient-to-r from-[#4FA0FF] to-[#1d8df5] hover:bg-[#0766A6] hover:scale-105 transition-all px-5 py-3 md:px-4 md:py-2
            rounded-xl font-semibold
            shadow-md 
            block text-center text-[white]"
                onClick={() => setMenuOpen(false)}
              >
                Apply Now
              </NavLink>
            )}
          </li>

          <li className="px-4 py-1">
            <NavLink
              to="/repayloan"
              className="border border-white/60
          text-white px-5 py-3 md:px-4 md:py-2
          rounded-xl hover:bg-white hover:text-[#0B1C3D]
          transition-all block text-center"
              onClick={() => setMenuOpen(false)}
            >
              Repay Loan
            </NavLink>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Header;
